import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'daysToMarket',
  pure: true,
})
export class DaysToMarketPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: any, args?: any): any {
    if (value !== isNaN) {
      const days: number = value;
      if (days === 0) {
        return value + ' ' + this.translate.instant('component.common.justnow');
      } else if (days === 1) {
        return value + ' ' + this.translate.instant('component.common.day');
      } else {
        return value + ' ' + this.translate.instant('component.common.days');
      }
    }
    return '';
  }
}
